import type React from 'react';

import { ArrowRightBig } from '@shared/assets';

import * as st from './styles.module.scss';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	productId: number;
}

export const VideoBtn: React.FC<Props> = ({ productId, ...props }) => {
	return (
		<button className={st.video} {...props}>
			<ArrowRightBig />
			<span>Видео</span>
		</button>
	);
};
